import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SolutionComponent } from './solution.component';

@NgModule({
  declarations: [SolutionComponent],
  imports: [CommonModule, RouterModule.forChild([])],
})
export class SolutionModule {}
